export enum EnvironmentType {
  Development = 'Development',
  QATest = 'QA Test',
  QALive = 'QA Live',
  Test = 'Test',
  Live = 'Live'
}
